import { render, staticRenderFns } from "./SidebarLinkGroup.vue?vue&type=template&id=cc97e6ac&scoped=true"
import script from "./SidebarLinkGroup.vue?vue&type=script&lang=js"
export * from "./SidebarLinkGroup.vue?vue&type=script&lang=js"
import style0 from "./SidebarLinkGroup.vue?vue&type=style&index=0&id=cc97e6ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc97e6ac",
  null
  
)

export default component.exports